import { StateCreator } from 'zustand'

export enum EUtmParam {
  SOURCE = 'utm_source',
  MEDIUM = 'utm_medium',
  CAMPAIGN = 'utm_campaign',
  CONTENT = 'utm_content',
  TERM = 'utm_term',
}

export enum EMarketingParam {
  FOCUS = 'focus',
}

type TUtmParamsDefinition = {
  [key in EUtmParam]?: string
}

type TMarketingParamsDefinition = {
  [key in EMarketingParam]?: string
}

type TPartnerUtmParamsDefinition = {
  [key: string]: string | undefined
}

type TTrackingParams = {
  utmParams: TUtmParamsDefinition
  marketingParams: TMarketingParamsDefinition
  partnerUtmParams: TPartnerUtmParamsDefinition
}

export type TMarketingState = TTrackingParams & {
  setUtmParams(utmParams: Partial<TUtmParamsDefinition>): void
  setMarketingParams(marketingParams: Partial<TMarketingParamsDefinition>): void
  setPartnerUtmParams(
    partnerUtmParams: Partial<TPartnerUtmParamsDefinition>,
  ): void
}

export const initialUtmParamsState: TUtmParamsDefinition = {}

export const initialMarketingParamsState: TMarketingParamsDefinition = {}

export const initialPartnerUtmParamsState: TPartnerUtmParamsDefinition = {}

const createMarketingSlice: StateCreator<
  TMarketingState,
  [['zustand/devtools', unknown]],
  []
> = (set) => ({
  utmParams: initialUtmParamsState,
  marketingParams: initialMarketingParamsState,
  partnerUtmParams: initialPartnerUtmParamsState,
  setUtmParams: (utmParams) =>
    set(
      (state) => ({
        utmParams: { ...state.utmParams, ...utmParams },
      }),
      undefined,
      {
        type: 'setUtmParams',
        utmParams,
      },
    ),
  setMarketingParams: (marketingParams) =>
    set(
      (state) => ({
        marketingParams: { ...state.marketingParams, ...marketingParams },
      }),
      undefined,
      {
        type: 'setMarketingParams',
        marketingParams,
      },
    ),
  setPartnerUtmParams: (partnerUtmParams) =>
    set(
      (state) => ({
        partnerUtmParams: {
          ...state.partnerUtmParams,
          ...partnerUtmParams,
        },
      }),
      undefined,
      {
        type: 'setPartnerUtmParams',
        partnerUtmParams,
      },
    ),
})

export default createMarketingSlice
